import { isFunction } from 'lodash-es'
import { FC } from 'react'
import resolveConfig from 'tailwindcss/resolveConfig'
import { ThemeConfig } from 'tailwindcss/types/config'

import tailwindConfig from '../../../tailwind.config'
import { ScreenSize } from '../constants/index'

const fullConfig = resolveConfig(tailwindConfig)

const asColorObject = (
  input: unknown
): Exclude<typeof input, FC | undefined> => {
  if (isFunction(input) || !input) {
    throw new Error(
      `Expected an object, but got a value of type: ${typeof input} (${String(
        input
      )}).`
    )
  }
  return input
}

const tailwindTheme = asColorObject(
  fullConfig.theme
) as Required<ThemeConfig> & {
  colors: ThemeConfig['colors']
  screens: ThemeConfig['screens']
}

type TWBreakpoints = {
  [K in ScreenSize]: number
}

export const breakpoints = Object.fromEntries(
  Object.entries(tailwindTheme?.screens || {})
    .reverse()
    .map(([name, _value], index, screensArray) => {
      const currentValue =
        index === 0 ? { max: '0px' } : screensArray[index - 1][1]
      return [name, currentValue]
    })
    .map(([name, value]) => {
      return [
        name,
        Number(
          value.max
            ? Math.round(Number(value.max.slice(0, -2))) + 1
            : value.slice(0, -2)
        )
      ]
    })
) as TWBreakpoints
